import manImg from "icons/man/man.png"

export default {
  img: manImg,
}
